import { base as viemBase } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const base = {
  displayName: 'Base',
  runtime: 'evm',
  viemChain: viemBase,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 3,

  decoration: {
    color: '#0052FF',
    contrastColor: getContrastColor('#0052FF'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'base-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://basescan.org',
        token: 'https://basescan.org/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    cowSwap: { chainKey: 'base', blockExplorerKey: '/base' },
    debridge: {
      chainKey: '8453',
      providerContract: '0xc1656B63D9EEBa6d114f6bE19565177893e5bCBF',
    },
    lifi: { chainKey: 'BAS' },
    stargate: { chainKey: 'base' },
    across: { chainKey: 'base' },
    xswap: { chainKey: '8453' },
    renegade: { chainKey: 'base' },
    okx: { chainKey: '8453' },
    kyberswap: { chainKey: 'base' },
    houdini: { chainKey: 'BASE' },
  }),
  services: defaultServices({
    codex: {
      networkId: 8453,
      nativeLiquidityAddress: '0x4200000000000000000000000000000000000006',
    },
    coingecko: {
      networkId: 'base',
      platformId: 'base',
    },
    coingeckoDex: {
      networkId: 'base',
    },
    defiLlama: { chainKeys: ['base'] },
    trm: { chainKey: 'base' },
    zerion: { chainKey: 'base' },
    qnStreams: {
      networkKey: 'base-mainnet',
    },
    safe: { shortName: 'base' },
    alchemy: { chainSlug: 'base-mainnet' },
    pimlico: { chainSlug: 'base' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
